export const featureDataCommercialInteriorPainting = {
    mainTitle: 'Why Choose HRD for Interior Painting?',
    items: [
        {
            number: '01',
            heading: 'Premium-Quality Paints & Coatings – We use low-VOC, eco-friendly, and high-durability paints for long-lasting performance.'
        },
        {
            number: '02',
            heading: 'Minimal Business Disruption – Our team works efficiently and strategically to reduce downtime.'
        },
        {
            number: '03',
            heading: 'Skilled & Certified Painters – Trained professionals ensuring clean, even, and streak-free finishes.'
        },
        {
            number: '04',
            heading: 'Comprehensive Prep Work – Surface cleaning, patching, and priming for optimal paint adhesion and durability.'
        },
        {
            number: '05',
            heading: 'Safety & Compliance – Adhering to industry safety standards for commercial projects.'
        }
    ],
    title: "Revitalize Your Commercial Space",
    subtitle:
        'From corporate offices and retail shops to hotels, warehouses, and multi-unit buildings, we provide expert interior painting services to elevate and protect your property.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/2Caulking&SealantRenewal/featuregridSection/fondo.png'
};
